module.exports = __webpack_public_path__ + "img/clean_precheck_2.e57e0517.svg";